import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import auth from "app/reducers/auth";
import comment from "comment/reducers/comment";
import companies from "companies/reducers/companies";
import contacts from "contacts/reducers/contacts";
import entities from "reducers/entities";
import pendingInvoiceWidget from "pendingInvoiceWidget/reducers/pendingInvoiceWidget";
import project from "project/reducers/project";
import projects from "projects/reducers/projects";
import rasInfo from "tdlrTemplateFields/reducers/rasInfo";
import report from "report/reducers/report";
import reports from "reports/reducers/reports";
import tdlrFields from "tdlrTemplateFields/reducers/tdlrFields";
import templates from "templates/reducers/templates";

const createRootReducer = (history) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    comment,
    companies,
    contacts,
    entities,
    pendingInvoiceWidget,
    project,
    projects,
    rasInfo,
    report,
    reports,
    tdlrFields,
    templates,
  });

export default createRootReducer;
